import React__default, { useState, useCallback, useEffect } from 'react';
import { Icon, Placeholder } from './styles.js';
import { sizes, COIN_SIZES } from './types.js';
import { ReactComponent as SvgZignalyCoin } from '../../../assets/icons/coins/zignaly-coin.svg.js';

var ZigCoinIcon = function (_a) {
    var _b = _a.size, size = _b === void 0 ? COIN_SIZES.Medium : _b, coin = _a.coin, _c = _a.className, className = _c === void 0 ? "" : _c, _d = _a.bucket, bucket = _d === void 0 ? "coins-binance" : _d, id = _a.id;
    var s = typeof size === "number" ? size : sizes[size];
    var _e = useState(""), src = _e[0], setSrc = _e[1];
    var onError = useCallback(function () { return setSrc(""); }, []);
    useEffect(function () {
        setSrc("https://res.cloudinary.com/zignaly/image/upload/c_scale,w_".concat(s, ",h_").concat(s, ",r_max/").concat(bucket, "/").concat(coin));
    }, [coin]);
    if (!coin)
        return null;
    return src ? (React__default.createElement(Icon, { src: src, alt: coin, size: s, className: className, onError: onError, id: id })) : coin.toLowerCase() === "zig" ? (React__default.createElement(SvgZignalyCoin, { width: sizes[size], height: sizes[size], id: id, alt: "zig" })) : (React__default.createElement(Placeholder, { size: s, className: className, as: "div", id: id }, coin[0]));
};

export { ZigCoinIcon as default };
